import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { TapToTopComponent } from './shared/components/tap-to-top/tap-to-top.component';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from './shared/services/loading.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule, TapToTopComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(public loader: LoadingService, private translate: TranslateService) {
    this.translate.addLangs(['it', 'en']);
    this.translate.setDefaultLang('it');
    this.translate.use('it');
  }
}
